import React, { Component, Fragment } from "react";
import ReduxForm from "./containers/Form";
import Stat from "./containers/Stat";
import { Panel } from "react-bootstrap";
import styled from "styled-components";
import { connect } from "react-redux";
import { changeLocation } from "redux/router/actions";
import Sites from "./containers/Sites";
import Site from "./containers/Site";
import Tabs from "./containers/Tabs";

const DividerVertical = styled.div`
  background: #ccc;
  float: left;
  width: 2px;
  height: 50px;
  margin: -10px 15px;
  position: relative;
  border-right: 1px solid #fff;
`;

const TableTitle = styled.h3`
  margin: 0;
  float: left;
  font-size: 12pt;
  margin: 5px 0;
`;

const PanelHeaderContainer = styled.div`
  width: 100%;
  height: 30px;
`;

class Pablisher extends Component {
  state = {
    active: false
  };

  onClick = () => {
    const { active } = this.state;
    this.setState({ active: !active });
  };

  changeLocation = () => {
    const { changeLocation } = this.props;
    changeLocation("/");
  };

  render() {
    const { match } = this.props;
    return (
      <Fragment>
        <Panel>
          <Panel.Heading>
            <PanelHeaderContainer>
              <button
                className="btn btn-sm btn-default pull-left"
                onClick={this.changeLocation}
              >
                &larr; Назад
              </button>
              <DividerVertical />
              <TableTitle>Детальная статистика</TableTitle>
              <Sites match={match} />
            </PanelHeaderContainer>
          </Panel.Heading>
          <Panel.Body>
            <Tabs match={match} />
            <Site match={match} />
          </Panel.Body>
        </Panel>
        <Panel>
          <Panel.Body>
            <ReduxForm {...this.props} />
            <Stat match={match} />
          </Panel.Body>
        </Panel>
      </Fragment>
    );
  }
}

export default connect(null, {
  changeLocation
})(Pablisher);
